import { useContext, useEffect } from "react";
import {
    GelScreenDetectorContext,
    GelRowLayout,
    GelContainerLite,
    GelParagraph,
    GelHeading2,
    GelSpinner,
    GelHeading6,
} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import { useCookies } from "react-cookie";
import styled from "@emotion/styled";
import ResponsiveContainer from "../../components/responsive.container";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../common/usercontext/user.context";
import { AdobeAnalytics } from "../../common/analytics/adobe-analytics";
import Accordion from "../../common/components/Accordion";
import ContactUsAlert from "../../common/components/InfoAlert";
import { useGetNeedHelpPageContent } from "../../common/api/graphQLDataFetch"

const NeedHelpPage = () => {
    const { global: { themeColorBackgroundLight, sizeBaseX15, sizeBaseX5, sizeBaseX10, sizeNone, sizeBaseX3 } } = getGelTokens()
const location = useLocation();
const { selectedSubSection, selectedQuestion, isFromHomePage } = location.state || {};
    const { screen, isXsScreen } = useContext(GelScreenDetectorContext) as GelScreenDetectorContext;
    const [{ tpid }] = useCookies(['tpid']);
    const navigate = useNavigate();
    const { contextData } = useContext(UserContext)
    const { data, isLoading } = useGetNeedHelpPageContent()

    if (contextData.memberDetails?.displayLegalDisclosure)
        navigate("/yourDeclaration");

    useEffect(() => {
        AdobeAnalytics.PushPageViewEvent(tpid)

    }, [tpid]);

    if (isLoading)
        return <GelSpinner medium overlay />

    const PageHeader = styled.div(() => ({
        padding: isXsScreen(screen) ? `${sizeBaseX15}px ${sizeBaseX5}px` : `${sizeBaseX15}px ${sizeBaseX10}px`,
        backgroundColor: themeColorBackgroundLight
    }));

    return (
        <GelContainerLite style={{ padding: sizeNone, overflow: "hidden" }}>
            <PageHeader >
                <GelHeading2>{data?.pageHeader}</GelHeading2>
                <GelParagraph style={{ paddingTop: sizeBaseX3 }}>
                    {data?.pageSubtext}
                </GelParagraph>
            </PageHeader>

            <ResponsiveContainer>
                <GelRowLayout style={{ padding: isXsScreen(screen) ? `${sizeBaseX10}px ${sizeBaseX5}px` : `${sizeBaseX5}px ${sizeBaseX10}px` }}>
                    <div>
                        <ContactUsAlert
                            title={data?.questionHeader}
                            body={data?.questionDescription.json.content[0].content[0].value}
                            style={{ marginBottom: isXsScreen(screen) ? '24px' : '40px' }} />

                        {(data?.faqs?.sections || []).map((section, sectionIndex, sectionArr) =>
                            <div
                                key={sectionIndex}
                                style={{ paddingBottom: sectionIndex !== sectionArr.length - 1 ? '24px' : '0px' }}
                            >
                                <GelHeading2 style={{ color: '#191919', paddingBottom: '8px' }}>{section?.title}</GelHeading2>
                                <GelParagraph style={{ color: '#667085', paddingBottom: '40px' }}>{section?.subtitle}</GelParagraph>
                                {(section?.subsections || []).map((subsection, subsectionIdx, subsectionarr) =>
                                    <div
                                        key={subsectionIdx}
                                        style={{ paddingBottom: subsectionIdx !== subsectionarr.length - 1 ? '40px' : '0px' }}
                                    >
                                        <GelHeading6 style={{ color: '#191919', paddingBottom: '8px', fontSize: '20px' }}>{subsection?.title}</GelHeading6>
                                        <GelParagraph style={{ color: '#667085', paddingBottom: '16px' }}>{subsection?.subtitle}</GelParagraph>

                                        {(subsection?.questions || [])?.map((question, questionIdx, questionArr) =>
                                            <Accordion title={question?.question} body={question?.answer} key={questionIdx} 
                                            selectedSubSection={subsectionIdx} selectedQuestion={questionIdx} isFromHomePage={isFromHomePage}
                                             style={{ paddingBottom: questionIdx !== questionArr.length - 1 ? '16px' : '0px' }} />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </GelRowLayout>
            </ResponsiveContainer>
        </GelContainerLite>
    );
}

export default NeedHelpPage;